//# sourceMappingURL=callout.mjs.map
/// <reference types="./callout.d.mts" />
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $colors from "../../ds/colors.mjs";
import * as $shadows from "../../ds/css/shadows.mjs";
import * as $text from "../../ds/typography/text.mjs";
import { toList, prepend as listPrepend } from "../../gleam.mjs";

function header_() {
  return $css.class$(
    toList([
      $css.compose($text.xs($text.medium)),
      $css.padding(px(8)),
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(4)),
      $css.border_radius_("8px 8px 0 0"),
    ]),
  );
}

function base() {
  return $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.border_radius(px(8)),
      $css.box_shadow($shadows.s()),
    ]),
  );
}

/**
 * ```gleam
 * callout.info([], [
 *   callout.header([], []),
 *   callout.content([], []),
 * ])
 * ```
 */
export function info(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(base()),
      $css.background($colors.light.blue_50),
      $css.child(header_(), toList([$css.background($colors.light.blue_200)])),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

/**
 * ```gleam
 * callout.success([], [
 *   callout.header([], []),
 *   callout.content([], []),
 * ])
 * ```
 */
export function success(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(base()),
      $css.background($colors.light.success_50),
      $css.child(
        header_(),
        toList([$css.background($colors.light.success_200)]),
      ),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

/**
 * ```gleam
 * callout.warning([], [
 *   callout.header([], []),
 *   callout.content([], []),
 * ])
 * ```
 */
export function warning(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(base()),
      $css.background($colors.light.warning_50),
      $css.child(
        header_(),
        toList([$css.background($colors.light.warning_200)]),
      ),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

/**
 * ```gleam
 * callout.error([], [
 *   callout.header([], []),
 *   callout.content([], []),
 * ])
 * ```
 */
export function error(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.compose(base()),
      $css.background($colors.light.error_50),
      $css.child(header_(), toList([$css.background($colors.light.error_200)])),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

/**
 * ```gleam
 * callout.info([], [
 *   callout.header([], []),
 *   callout.content([], []),
 * ])
 * ```
 */
export function header(attrs, children) {
  let attrs$1 = listPrepend($a.class$("header"), attrs);
  let _pipe = header_();
  return $h.div(_pipe, attrs$1, children);
}

/**
 * ```gleam
 * callout.info([], [
 *   callout.header([], []),
 *   callout.content([], []),
 * ])
 * ```
 */
export function content(attrs, children) {
  let attrs$1 = listPrepend($a.class$("content"), attrs);
  let _pipe = $css.class$(
    toList([
      $css.compose($text.xs($text.regular)),
      $css.padding(px(8)),
      $css.display("grid"),
    ]),
  );
  return $h.div(_pipe, attrs$1, children);
}
